module.exports = __webpack_public_path__ + "img/21_BC22_god_gone_missing.0253c822.jpg";